import { client } from "../../client";
import { safeTags } from "../../encoding";

/**
 * Handle the change of players in an area.
 * @param {Array} args packet arguments
 */
export const handleARUP = (args: string[]) => {
  args = args.slice(1);
  for (let i = 0; i < args.length - 1; i++) {
    if (client.areas[i]) {
      // the server sends us ARUP before we even get the area list
      const thisarea = document.getElementById(`area${i}`)!;
      switch (Number(args[0])) {
        case 0: // playercount
          client.areas[i].players = Number(args[i + 1]);
          break;
        case 1: // status
          client.areas[i].status = safeTags(args[i + 1]);
          break;
        case 2:
          client.areas[i].cm = safeTags(args[i + 1]);
          break;
        case 3:
          client.areas[i].locked = safeTags(args[i + 1]);
          break;
      }

      thisarea.className = `area-button area-${client.areas[
        i
      ].status.toLowerCase()}`;

      // AO2-style multi-line layout so all info is visible without hovering:
      //   AREA NAME
      //   STATUS | CM   (CM omitted when there are no CMs)
      //   N users | LOCK
      const cm = client.areas[i].cm || "";
      const cmLower = cm.trim().toLowerCase();
      const hasCM = cmLower !== "" && cmLower !== "free" && cmLower !== "none";
      const statusLine = hasCM
        ? `${client.areas[i].status} | ${cm}`
        : `${client.areas[i].status}`;
      const playersLine = `${client.areas[i].players} users | ${client.areas[i].locked}`;

      thisarea.innerHTML = "";
      const nameEl = document.createElement("span");
      nameEl.className = "area-name";
      nameEl.textContent = client.areas[i].name;
      const statusEl = document.createElement("span");
      statusEl.className = "area-status";
      statusEl.textContent = statusLine;
      const playersEl = document.createElement("span");
      playersEl.className = "area-players";
      playersEl.textContent = playersLine;
      thisarea.append(nameEl, statusEl, playersEl);

      thisarea.title =
        `Players: ${client.areas[i].players}\n` +
        `Status: ${client.areas[i].status}\n` +
        `CM: ${client.areas[i].cm}\n` +
        `Area lock: ${client.areas[i].locked}`;
    }
  }
};
